/* eslint-disable spaced-comment */
/// <reference path="./dependency-shims.d.ts" />

/* eslint-disable import/no-extraneous-dependencies, import/no-webpack-loader-syntax, import/no-unresolved, max-len */
// Must precede the lib/ import: ES module imports evaluate in declaration order.
import './jquery-global';
import awa from 'exports-loader?awa!./lib/jsll-4.2.14';

// If JSLL was previously imported by a separate component (e.g. Adobe Omniture), then don't
// override the global value, otherwise it’ll throw an exception.
if (!window.awa) {
  window.awa = awa;
}

export { awa };
export type { Awa, CorrelationVectorApi } from './types';
